(function () {
'use strict';
var cfg = window.BRON_POPUP || {};
if (!cfg.enabled) return;
if (document.getElementById('bron-pop')) return;
var DONE_KEY = 'bron_popup_done';
var DISMISS_KEY = 'bron_popup_dismissed';
var SEEN_KEY = 'bron_popup_seen';
var SUPPRESS_MS = (cfg.suppress || 14) * 86400000;
var DELAY_MS = (cfg.delay || 8) * 1000;
/* ---- suppression / context gates ---- */
try {
if (window.Shopify && window.Shopify.designMode) return;
if (/\/(checkout|cart)/.test(location.pathname)) return;
if (sessionStorage.getItem(SEEN_KEY)) return;
if (localStorage.getItem(DONE_KEY)) return;
var dis = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
if (dis && Date.now() - dis < SUPPRESS_MS) return;
} catch (e) { return; }
function esc(s) {
return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
/* ---- styles ---- */
var css = ''
+ '#bron-pop{position:fixed;inset:0;z-index:120;display:none;align-items:center;justify-content:center;padding:20px}'
+ '#bron-pop.is-on{display:flex}'
+ '#bron-pop .scrim{position:absolute;inset:0;background:rgba(0,0,0,0.7)}'
+ '#bron-pop .panel{position:relative;overflow:hidden;width:100%;max-width:540px;min-height:360px;background:#0a0a0a;border:1px solid rgba(245,244,241,0.22);color:#f5f4f1;animation:bronPopIn .25s ease}'
+ '@keyframes bronPopIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}'
+ '#bron-pop .bg{position:absolute;inset:0;background-size:cover;background-position:right center;z-index:0}'
+ '#bron-pop .ov{position:absolute;inset:0;pointer-events:none}'
+ '#bron-pop .ov1{z-index:1;background:linear-gradient(90deg, rgba(10,10,10,0.95) 0%, rgba(10,10,10,0.82) 42%, rgba(10,10,10,0.30) 100%)}'
+ '#bron-pop .ov2{z-index:1;background:radial-gradient(circle at 88% 50%, rgba(199,62,46,0.12) 0%, rgba(199,62,46,0) 60%)}'
+ '#bron-pop .inner{position:relative;z-index:2;padding:46px 44px 38px;max-width:80%}'
+ '#bron-pop .corner{position:absolute;z-index:3;width:16px;height:16px;border:1px solid #C73E2E;pointer-events:none}'
+ '#bron-pop .corner.tl{top:8px;left:8px;border-right:0;border-bottom:0}'
+ '#bron-pop .corner.br{bottom:8px;right:8px;border-left:0;border-top:0}'
+ '#bron-pop .x{position:absolute;z-index:4;top:12px;right:12px;width:38px;height:38px;background:rgba(10,10,10,0.6);border:1px solid rgba(245,244,241,0.5);cursor:pointer;transition:background .15s,border-color .15s}'
+ '#bron-pop .x span{position:absolute;left:10px;right:10px;top:50%;height:1.5px;background:#f5f4f1;transition:background .15s}'
+ '#bron-pop .x span:first-child{transform:translateY(-0.75px) rotate(45deg)}'
+ '#bron-pop .x span:last-child{transform:translateY(-0.75px) rotate(-45deg)}'
+ '#bron-pop .x:hover{background:#C73E2E;border-color:#C73E2E}'
+ '#bron-pop .x:hover span{background:#f5f4f1}'
+ '#bron-pop .eb{font-family:var(--bron-font-mono, "Courier New", monospace);text-transform:uppercase;letter-spacing:0.26em;font-size:11px;color:#C73E2E;font-weight:700;margin-bottom:18px}'
+ '#bron-pop .head{font-family:var(--bron-font-display, Impact, "Arial Narrow", sans-serif);font-weight:900;text-transform:uppercase;font-size:clamp(44px, 9vw, 60px);line-height:0.9;letter-spacing:-0.01em;margin-bottom:16px}'
+ '#bron-pop .head .red{color:#C73E2E}'
+ '#bron-pop .sub{font-family:var(--bron-font-body, "Helvetica Neue", sans-serif);font-size:15px;line-height:1.55;color:#c9c7c2;margin:0 0 26px;max-width:34ch}'
+ '#bron-pop .row{display:grid;grid-template-columns:1fr auto;border:1px solid rgba(245,244,241,0.38);background:rgba(10,10,10,0.55)}'
+ '#bron-pop .row input{background:transparent;border:0;padding:16px 16px;color:#f5f4f1;font-family:var(--bron-font-mono, "Courier New", monospace);text-transform:uppercase;letter-spacing:0.16em;font-size:12px;min-width:0}'
+ '#bron-pop .row input::placeholder{color:#8a8884}'
+ '#bron-pop .row input:focus{outline:0}'
+ '#bron-pop .row:focus-within{border-color:#f5f4f1}'
+ '#bron-pop .row button{padding:0 22px;background:#f5f4f1;color:#0a0a0a;border:0;font-family:var(--bron-font-mono, "Courier New", monospace);text-transform:uppercase;letter-spacing:0.2em;font-size:11px;font-weight:700;cursor:pointer;transition:background .15s, color .15s;white-space:nowrap}'
+ '#bron-pop .row button:hover{background:#C73E2E;color:#f5f4f1}'
+ '#bron-pop .row button:disabled{opacity:.5;cursor:wait}'
+ '#bron-pop .msg{font-family:var(--bron-font-mono, "Courier New", monospace);text-transform:uppercase;letter-spacing:0.16em;font-size:11px;color:#C73E2E;min-height:18px;margin-top:12px}'
+ '#bron-pop .msg.ok{color:#f5f4f1}'
+ '#bron-pop .stamps{display:flex;gap:24px;margin-top:18px;font-family:var(--bron-font-mono, "Courier New", monospace);text-transform:uppercase;letter-spacing:0.2em;font-size:11px;color:#8a8884}'
+ '#bron-pop .code{display:flex;align-items:stretch;border:1px dashed #C73E2E;background:rgba(199,62,46,0.10);margin:0 0 20px;max-width:340px}'
+ '#bron-pop .code .codeval{flex:1;display:flex;align-items:center;padding:13px 16px;font-family:var(--bron-font-display, Impact, "Arial Narrow", sans-serif);font-weight:900;text-transform:uppercase;letter-spacing:0.08em;font-size:20px;color:#f5f4f1}'
+ '#bron-pop .code .codecopy{padding:0 18px;background:#C73E2E;color:#f5f4f1;border:0;font-family:var(--bron-font-mono, "Courier New", monospace);text-transform:uppercase;letter-spacing:0.16em;font-size:11px;font-weight:700;cursor:pointer;transition:background .15s, color .15s}'
+ '#bron-pop .code .codecopy:hover{background:#f5f4f1;color:#0a0a0a}'
+ '#bron-pop .success{display:none}'
+ '#bron-pop.is-success .formwrap{display:none}'
+ '#bron-pop.is-success .success{display:block}'
+ '@media (max-width:560px){'
+   '#bron-pop .panel{min-height:320px}'
+   '#bron-pop .inner{padding:38px 24px 30px;max-width:100%}'
+   '#bron-pop .ov1{background:linear-gradient(90deg, rgba(10,10,10,0.95) 0%, rgba(10,10,10,0.9) 55%, rgba(10,10,10,0.55) 100%)}'
+   '#bron-pop .row{grid-template-columns:1fr}'
+   '#bron-pop .row input{padding:15px 16px}'
+   '#bron-pop .row button{padding:15px}'
+ '}';
var styleEl = document.createElement('style');
styleEl.textContent = css;
document.head.appendChild(styleEl);
/* ---- markup ---- */
var bgDiv = (cfg.showBg && cfg.bg)
? '<div class="bg" style="background-image:url(\'' + cfg.bg + '\')" aria-hidden="true"></div>'
: '';
var root = document.createElement('div');
root.id = 'bron-pop';
root.className = 'bron-pop';
root.setAttribute('role', 'dialog');
root.setAttribute('aria-modal', 'true');
root.setAttribute('aria-label', 'Email signup');
root.setAttribute('aria-hidden', 'true');
root.innerHTML = ''
+ '<div class="scrim" data-close aria-hidden="true"></div>'
+ '<div class="panel">'
+   bgDiv
+   '<div class="ov ov1" aria-hidden="true"></div>'
+   '<div class="ov ov2" aria-hidden="true"></div>'
+   '<span class="corner tl" aria-hidden="true"></span>'
+   '<span class="corner br" aria-hidden="true"></span>'
+   '<button type="button" class="x" data-close aria-label="Close"><span></span><span></span></button>'
+   '<div class="inner">'
+     '<div class="formwrap">'
+       '<div class="eb">' + esc(cfg.eyebrow) + '</div>'
+       '<div class="head">' + esc(cfg.l1) + '<br>' + esc(cfg.l2) + '<span class="red">.</span></div>'
+       '<p class="sub">' + esc(cfg.body) + '</p>'
+       '<form class="row" data-form novalidate>'
+         '<input type="email" name="email" required placeholder="' + esc(cfg.placeholder) + '" aria-label="Email" autocomplete="email" />'
+         '<button type="submit">' + esc(cfg.button) + '&nbsp;▸▸</button>'
+       '</form>'
+       '<div class="msg" data-msg aria-live="polite"></div>'
+       '<div class="stamps"><span>▪ No spam</span><span>▪ Unsubscribe anytime</span></div>'
+     '</div>'
+     '<div class="success" data-success aria-hidden="true">'
+       '<div class="eb ok">▪ Confirmed</div>'
+       '<div class="head">' + esc(cfg.successHead) + '<span class="red">.</span></div>'
+       '<p class="sub">' + esc(cfg.successBody) + '</p>'
+       (cfg.code ? '<div class="code"><span class="codeval" data-codeval>' + esc(cfg.code) + '</span><button type="button" class="codecopy" data-copy>Copy</button></div>' : '')
+       '<div class="stamps"><span>▪ Use at checkout</span><span>▪ Check your inbox</span></div>'
+     '</div>'
+   '</div>'
+ '</div>';
document.body.appendChild(root);
/* ---- behavior ---- */
function open() { root.classList.add('is-on'); root.setAttribute('aria-hidden', 'false'); try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {} }
function close() {
root.classList.remove('is-on');
root.setAttribute('aria-hidden', 'true');
try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) {}
}
setTimeout(open, DELAY_MS);
root.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && root.classList.contains('is-on')) close();
});
var form = root.querySelector('[data-form]');
var msg = root.querySelector('[data-msg]');
var success = root.querySelector('[data-success]');
form.addEventListener('submit', function (e) {
e.preventDefault();
var email = (form.email.value || '').trim();
if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
msg.classList.remove('ok');
msg.textContent = 'Enter a real email.';
return;
}
var btn = form.querySelector('button');
btn.disabled = true;
msg.textContent = '';
fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
body: JSON.stringify({
data: {
type: 'subscription',
attributes: {
profile: { data: { type: 'profile', attributes: { email: email, properties: { source: 'site popup' } } } }
},
relationships: { list: { data: { type: 'list', id: cfg.list } } }
}
})
}).then(function (r) {
if (r.status === 202 || r.ok) {
try { localStorage.setItem(DONE_KEY, '1'); } catch (e) {}
if (success) { root.classList.add('is-success'); success.setAttribute('aria-hidden', 'false'); }
} else {
throw new Error('status ' + r.status);
}
}).catch(function () {
btn.disabled = false;
msg.classList.remove('ok');
msg.textContent = 'Something broke. Try again.';
});
});
function bronFallbackCopy(text) { try { var ta = document.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); } catch (e) {} }
var copyBtn = root.querySelector('[data-copy]');
if (copyBtn) {
copyBtn.addEventListener('click', function () {
var code = cfg.code || '';
var done = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800); };
if (navigator.clipboard && navigator.clipboard.writeText) {
navigator.clipboard.writeText(code).then(done).catch(function () { bronFallbackCopy(code); done(); });
} else { bronFallbackCopy(code); done(); }
});
}
})();
